import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import '../styles.less'
import { getEfillingSummaryReport } from '../../../redux/actions/eFilling'
import SummaryReporteFillingWidget from '../../../widgets/eFillingListFormWidgets/SummaryReporteFillingWidget'

export default function eFillingSummaryReportApprover() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const pageNumber = 0
  const pageSize = 0

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEfillingSummaryReport(projectCode)
      setSchema(response.model)
      // console.log('response==>', response)
      // setSchema(mockSchema.model)
      // console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <SummaryReporteFillingWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
